module.exports = __webpack_public_path__ + "files/d25b9fea47c5379876b9ef777ee030bc.svg";